var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CleanCharacterConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { getRenamedColumns } from './toolConfigUtil';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { buildInputsMap, isSourceValid } from './validation/validateHelper';
import { cleanCharacterConfigSchemaValidation } from '../validations.generated';
export const cleanCharacterConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:CleanCharacterConfig',
    type: 'object',
    properties: {
        cleanConditions: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:CleanCharacterCondition' },
            minItems: 1
        }
    },
    required: ['cleanConditions']
};
let CleanCharacterConfig = CleanCharacterConfig_1 = class CleanCharacterConfig extends ToolConfig {
    constructor(cleanConditions, customFormats) {
        super(ToolType.CLEAN_CHARACTER, customFormats);
        this.cleanConditions = cleanConditions;
        JSON.validate(this, CleanCharacterConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return CleanCharacterConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return CleanCharacterConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return CleanCharacterConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return CleanCharacterConfig_1.outs;
    }
    static get in() {
        return CleanCharacterConfig_1.ins[0];
    }
    static get out() {
        return CleanCharacterConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.CLEAN_CHARACTER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CLEAN], this.ins, this.outs, ['remove', 'replace', 'clean', 'special characters', 'remove characters', 'ascii', 'unicode'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        if (source) {
            const exp = tsb.export(this.out);
            const replaces = new Set();
            const newCols = new Set();
            this.cleanConditions
                .filter((cleanCondition) => cleanCondition.addNewColumn !== true)
                .map((cleanCondition) => cleanCondition.columns)
                .forEach((cleanConditionColumns) => cleanConditionColumns.forEach((column) => replaces.add(column)));
            this.cleanConditions
                .filter((cleanCondition) => cleanCondition.addNewColumn === true)
                .map((cleanCondition) => cleanCondition.columns)
                .forEach((cleanConditionColumns) => cleanConditionColumns.forEach((column) => newCols.add(column)));
            const isReplaceColumn = replaces.size > 0
                ? (column) => {
                    return replaces.has(column.name);
                }
                : (column) => {
                    return newCols.size === 0 && column.type === 'string';
                };
            // replaced columns
            source.forEach((s) => {
                const isReplace = isReplaceColumn(s);
                exp.copy(this.in, s, isReplace, isReplace);
            });
            // new columns
            const dependents = this.getDependents(exp, this.in, Array.from(new Set([...replaces, ...newCols])));
            const allColumns = source.map((col) => col.name);
            newCols.forEach((col) => {
                const newColName = getRenamedColumns(allColumns, `${col}_cleaned`, this.toolType);
                exp.makeNew(new Column(newColName, 'string'), dependents, true);
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const cleans = new Set();
        this.cleanConditions
            .map((cleanCondition) => cleanCondition.columns)
            .forEach((cleanConditionColumns) => cleanConditionColumns.forEach((column) => cleans.add(column)));
        const inputs = buildInputsMap([...cleans], ['string']);
        return isSourceValid(source, inputs, []) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
CleanCharacterConfig = CleanCharacterConfig_1 = __decorate([
    JsonSchemaV2(cleanCharacterConfigSchema, cleanCharacterConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.CLEAN_CHARACTER)
], CleanCharacterConfig);
export { CleanCharacterConfig };
//# sourceMappingURL=cleanCharacterConfig.js.map